import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'

//const weatherAdapter = createEntityAdapter()

const initialState = {
  weatherData: {
    status: "idle",
    data: {},
    error: {},
  },
}

export const fetchWeather = createAsyncThunk('weather', async (data) => {
  const { token } = data
       const axios = require("axios")
       const headers = {
                 "Authorization" : `Bearer ${token}`,
                  "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
          }
       const response = await axios.get('/api/v0/weather/YILI', 
                 { headers })
      return response.data
})

const weatherSlice = createSlice({
  name: 'weather',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchWeather.pending.type]:(state, action) => {
      state.weatherData = {
        status: "loading",
        data: {},
        error: {},
      }
    },
    [fetchWeather.fulfilled.type]:(state, action) => {
      state.weatherData = {
        status: "idle",
        data: action.payload,
        error: {},
      }
    },
    [fetchWeather.rejected.type]:(state, action) => {
      state.weatherData = {
        status: "idle",
        data: {},
        error: "unauthorized",
      }
    },
  }
})

export default weatherSlice.reducer